// extracted by mini-css-extract-plugin
module.exports = {"container":"review_container__vhuAd","publicParticipant":"review_publicParticipant__kLmKW","representative":"review_representative__eDH36"};